export const blockedCharsInCompanyNames = `@#$%*+=|/<>\\[\\]{}:;"~!?^_\\\\`;
export const blockedCharsInNames = `${blockedCharsInCompanyNames}()0-9`;
/**
 * Creates a validation regex pattern that blocks problematic special characters
 * while allowing international characters and common punctuation.
 *
 * @param additionalBlockedChars - Additional blocked characters (e.g., '&,()', etc.)
 * @returns RegExp for validation
 */
function createValidationRegex(blockedCharacters) {
    return new RegExp(`^[^${blockedCharacters}]*$`);
}
export const nameValidationRegex = createValidationRegex(blockedCharsInNames);
export const companyNameValidationRegex = createValidationRegex(blockedCharsInCompanyNames);
/**
 * Creates PostgreSQL-compatible regex validation pattern for database operations
 * @param additionalBlockedChars - Additional blocked characters (e.g., '&,()', etc.)
 * @returns PostgreSQL regex validation pattern string
 */
export function createPostgreSQLValidationPattern(rawBlockedCharacters) {
    const chars = [...rawBlockedCharacters];
    const escaped = chars
        .map((char) => {
        //escape mandatory to be able tu use this expression in the entity (with E) that will be then correctly formatted from TS migration to SQL pattern
        if (char === "\\") {
            return "\\\\\\\\";
        }
        return char;
    })
        .join("");
    return `^[^${escaped}]*$`;
}
export const namePostgreSQLPattern = createPostgreSQLValidationPattern(blockedCharsInNames);
export const companyNamePostgreSQLPattern = createPostgreSQLValidationPattern(blockedCharsInCompanyNames);
export const hexColorValidationRegex = /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{4}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/;
